import { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { UserContext } from '../UserContext'
import { getParticipantTreesForUser } from '../../../services/userService'
import useNotifications from '../../../hooks/useNotifications'
import { getPersonCount } from '../../../services/treeService'

export default function useUserParticipantTrees() {
  const userContext = useContext(UserContext)
  const [participantTrees, setParticipantTrees] = useState([])
  const { error } = useNotifications()
  const { t } = useTranslation()

  useEffect(() => {
    const applyPersonCount = async (participantTree) => {
      const personCount = await getPersonCount(participantTree.tree.treeId).catch((err) => {
        error(
          t('tree.error.personCount', 'Error getting persons count for tree {treeId}: {message}', {
            treeId: participantTree.tree.treeId,
            message: err.message,
          })
        )
      })
      participantTree.tree.personCount = personCount.data
    }

    userContext?.currentUser?.dmcUser?.cisId &&
      getParticipantTreesForUser(userContext.currentUser.dmcUser.cisId)
        .then(async (response) => {
          await Promise.allSettled(
            response.data.map(async (participantTree) => {
              await applyPersonCount(participantTree)
              return participantTree
            })
          )
          setParticipantTrees(response.data)
        })
        .catch((err) => {
          error(
            t(
              'user.tree.errors.getParticipantTrees',
              `Error getting trees that this user participates in - {message}`,
              {
                message: err.message || '',
              }
            )
          )
        })
  }, [error, t, userContext.currentUser.dmcUser.cisId])

  return { participantTrees }
}
